import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { isNullOrUndefined } from 'util';
import { Constants } from '../constants/constants';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { ToastService } from '../service/toast.service';
import { UtilService } from '../service/util.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

  @ViewChild('contactUsForm', { static: true }) public contactUsForm: NgForm;
  contactUsModel: ContactUsModel = new ContactUsModel();

  loggedInUser: any =  null;
  
  constructor(public apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toastService: ToastService) { 
    // this.authService.authenticationState.subscribe(state => {
    //   // console.log("Auth changed..:", state);
    //   this.resetForm();
    //   if(state) {
    //     this.loggedInUser = this.authService.loggedInUser;
    //     this.initModel();
    //   } else {
    //     this.loggedInUser = null;
    //   }
    // });
  }

  ngOnInit() {
    
  }

  openForm() {
    this.loggedInUser = this.authService.loggedInUser;
    // this.resetForm();
    this.initModel();
    document.getElementById('openContactUsModal').click();
  }

  resetForm() {
    if(!isNullOrUndefined(this.contactUsForm)) {
      this.contactUsForm.reset();
      this.contactUsForm.resetForm();
      this.contactUsForm.form.markAsPristine();
    }
    // this.initModel();
  }

  initModel() {
    // console.log("init model called:", this.loggedInUser);
    this.contactUsModel = new ContactUsModel();
    if(!isNullOrUndefined(this.loggedInUser)) {
      this.contactUsModel.userId = this.loggedInUser.userId;
      this.contactUsModel.email = this.loggedInUser.email;
      this.contactUsModel.name = this.loggedInUser.name;
      this.contactUsModel.phone = this.loggedInUser.phoneNumber;
    }
    // console.log("inside model:", this.contactUsModel);
  }

  saveClicked(form: NgForm) {
    this.contactUsForm = form;
    if (form.valid) {
      console.log("contact us : ", this.contactUsModel);
      this.utilService.showSpinner();
      this.apiService.contactUs(this.contactUsModel).then((data) => {
        this.utilService.hideSpinner();
        this.resetForm();
        document.getElementById('closeContactUsModal').click();
        document.getElementById('openConfirmationModel').click();
      }).catch((error) => {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      });
    }
  }

  cancelClicked() {
    this.resetForm();
  }
}


export class ContactUsModel {
  public userId: string = null;
  public name: string = null;
  public email: string = null;
  public phone: string = null;
  public subject: string = null;
  public message: string = null;
}